export const URLS = {
    GET_METRICS_BY_MODULE: 'modules/get_module',
    GET_ACTIONS_BY_MODULE: 'actions/get_by_module',
    RUN_METRICS_QUERY: 'metrics/run_query',
    GET_METRICS: 'metrics/get_metrics',
    SYNC_EVENTS_DATA: 'es/sync_data/event_logs',
    EXPORT_MODULE: 'modules/export_module',
    EDIT_MODULE: 'modules/edit_module',
    GET_EVENTS: 'events/get_all_events',
    GET_ACTION_URL: 'actions/get_action',
    GET_ORG_URL: 'org/get_all_orgs'
}

export const METRIC_TYPES = {
    METRIC_CARD: 'METRIC_CARD',
    METRIC_CARD_LITE: 'METRIC_CARD_LITE',
    METRIC_TABLE: 'METRIC_TABLE',
    BAR_CHART: 'BAR_CHART',
    JOURNEY_CHART_REALTIME: 'JOURNEY_CHART_REALTIME',
    FILTERS: 'FILTERS',
    PIE_DONUT_CHART: 'PIE_DONUT_CHART',
    LINE_CHART: 'LINE_CHART',
    AREA_CHART: 'AREA_CHART'
}

export const EVENTS_TOKEN = '39e57556de8f34f96abfaa07cd89f5f93673ea64a25982113266e3b99b6ced02';
